import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.4735 5.47357C12.4116 5.41108 12.3378 5.36148 12.2566 5.32764C12.1753 5.29379 12.0882 5.27637 12.0002 5.27637C11.9122 5.27637 11.8251 5.29379 11.7438 5.32764C11.6626 5.36148 11.5888 5.41108 11.5269 5.47357L8.47354 8.52689C8.41156 8.58938 8.33783 8.63897 8.25659 8.67282C8.17535 8.70667 8.08821 8.72409 8.0002 8.72409C7.9122 8.72409 7.82506 8.70667 7.74382 8.67282C7.66258 8.63897 7.58885 8.58938 7.52687 8.52689L4.47354 5.47357C4.41156 5.41108 4.33783 5.36148 4.25659 5.32764C4.17535 5.29379 4.08821 5.27637 4.0002 5.27637C3.91219 5.27637 3.82506 5.29379 3.74382 5.32764C3.66258 5.36148 3.58884 5.41108 3.52687 5.47357C3.4027 5.59847 3.33301 5.76744 3.33301 5.94356C3.33301 6.11969 3.4027 6.28866 3.52687 6.41356L6.58687 9.47356C6.96187 9.84809 7.4702 10.0585 8.0002 10.0585C8.53021 10.0585 9.03854 9.84809 9.41354 9.47356L12.4735 6.41356C12.5977 6.28866 12.6674 6.11969 12.6674 5.94356C12.6674 5.76744 12.5977 5.59847 12.4735 5.47357Z"
      fill="#151718"
    />
  </svg>
);

const SelectArrow = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default SelectArrow;
